import { RouteConfig, Route, NavigationGuardNext } from "vue-router";
import FilePathService from '@/apps/shared/services/filePath-service';
import { safeRedirect } from '@/apps/shared/utils/safeRedirectHelper';
const tabOneWelcome = () => import("./quote/views/tab-one.vue");
const tabTwoCalculator = () => import("./quote/views/tab-two.vue");
const pageTitle = 'Seguro de Retiro | Sancor Seguros';
const contentMetaData = ''


const routes: Array<RouteConfig> = [
    {
        path: "/calculadoraretiro/cotizarRetiro",
        name: "cotizador-retiro",
        component: tabTwoCalculator,
        meta: {
            title: () => 'CalculadoraRetiro',
            pageTitle: pageTitle,
            layout: 'retiro',
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                }
            ]

        },
    },
    // Ruta comod�n debe ir al final siempre
    {
        path: "/calculadoraretiro/:subpath*",
        name: "tabOne",
        component: tabOneWelcome,
        meta: {
            title: () => 'Datos personales',
            pageTitle: pageTitle,
            layout: 'retiro',
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                }
            ]
        },
        beforeEnter: async (to: any, from: any, next: any): Promise<void> => {
            NF.UI.Page.block();
            try {
                const subpath = to.params?.subpath;

                if (!subpath || (Array.isArray(subpath) ? subpath.length === 0 : String(subpath).trim() === "")) {
                    const response = await FilePathService.getFilePath("Retiro")
                    await safeRedirect(response.toString(), next);
                }
                else {
                    next();
                }

            }
            catch {
                next({ name: 'not-found' });
            } finally {
                NF.UI.Page.unblock();
            }
        }
    },
];

export default routes;